// extracted by mini-css-extract-plugin
export default {"Disclaimer":"Disclaimer_Disclaimer__3WtkG","DisclaimerContentBox":"Disclaimer_DisclaimerContentBox__n7fg6","DisclaimerLabel":"Disclaimer_DisclaimerLabel__Yhq0D"};